export default {
  CLOSE: 'Schließen',
};
